module.exports = __webpack_public_path__ + "img/fs.3a65ede1.svg";